module.exports = __webpack_public_path__ + "img/insurance-logo-8.8d86008d.png";